import { IPromise } from "angular";
import ActionDispatcherService from "../common/actions/core/action-dispatcher.service";
import AuthAwareController from "../common/services/auth/auth-aware.controller";
import GlobalSpinnerService from "../common/services/spinner/global-spinner.service";
import { GsmOperator, UserResponse } from "../common/services/user/user.model";
import UserService from "../common/services/user/user.service";
import { OpenPacketDeleteAction } from "../packet/packet-delete-dialog/packet-delete-dialog.action";
import { OpenPacketDeleteSuccessAction } from "../packet/packet-delete-success-dialog/packet-delete-success-dialog.action";
import {
  PackageThumbnail,
  ListeningPackageType,
  UserListeningPackagesResponse,
  StudentPlan,
  StudentPlanStatus
} from "../common/services/package/package.model";
import PackageService from "../common/services/package/package.service";
import { PaycellService } from "../buy/services/paycell.service";
import MobileService from "../common/services/mobile.service";
import GoogleAnalyticsService from "../common/services/analytics/google-analytics.service";
import { ProductImpressionEvent, Ecommerce,Product, ProductClickEvent } from "../common/services/analytics/events/dimensions";
import { OpenCampaignDialogAction } from "../components/campaign-dialog/campaign-dialog.action";
import StudentPlanService from "../common/services/package/student.service";
import HttpService from "../common/services/http.service";

/* @ngInject */
export default class MyAccountController extends AuthAwareController {
  public title = "Subscription page";
  public user: UserResponse;
  private packages: PackageThumbnail[] = [];
  private paycellPackages: PackageThumbnail[] = [];
  public authenticated: boolean = false;
  public selectedPackages: PackageThumbnail[] = [];
  public showDiv: boolean = false;
  public p:ProductImpressionEvent;
  /*public description: string;
  public description2: string;*/

  private activePackages: PackageThumbnail[] = [];
  private isLocalUser = false;
  private clicked = false;
  private planDetailclicked = false;
  private paycellPackageType: ListeningPackageType;
  private notOffer: boolean;

  private ecommerce:Ecommerce = new Ecommerce();
  private product:Product = new Product();
  private productList:Product[] = [];

  constructor(
    actionDispatcher: ActionDispatcherService,
    userService: UserService,
    httpService: HttpService,
    private $q,
    private $sce,
    private packageService: PackageService,
    private paycellService: PaycellService,
    private globalSpinner: GlobalSpinnerService,
    private mobileService: MobileService,
    private googleAnalytics: GoogleAnalyticsService,
    private studentPlanService: StudentPlanService,
    private $state,
    private $stateParams,
    private config,
    private $translate
  ) {
    super(actionDispatcher, userService, httpService);
  }

  protected loadAuthDependentData() {
    this.resetAuthDependentData();
    this.globalSpinner.start();
    this.authenticated = true;
    this.userPackagesPromise().finally(() => {
      this.globalSpinner.stop();
      if (this.$stateParams.from === 'buySuccess' || this.$stateParams.buySuccess === '1') {
        this.clicked = true;
      }
    });
    this.paycellPackageType = ListeningPackageType.CREDITCARD;
    this.googleAnalytics.writeVirtualPages({
      event: 'GAVirtual',
      virtualPageTitle: 'Paketler',
      virtualPageURL: '/packages'
    });
  }

  public getDescContent(packetDescription: PackageThumbnail) {
    return packetDescription.descContent || packetDescription.description;
  }

  protected resetAuthDependentData() {
    this.authenticated = false;
    this.packages = [];
    this.paycellPackages = [];
    this.activePackages = [];
    this.selectedPackages = [];
  }

  private userPackagesPromise(): IPromise<any> {
    localStorage.removeItem('userHasYearlyContracted');
    localStorage.removeItem('userHasYearly');
    return this.$q
      .when(this.userService.isLocalUserPromise())
      .then(isLocal => {
        this.isLocalUser = isLocal;
      })
      .then(() => {
        return this.$q
          .all([
            this.userService.getUserInfo(),
            this.packageService.getUserListeningPackages(),
            this.studentPlanService.getUserStudentStatus()
          ])
          .then(data => {
            this.user = data[0];
            const listeningPackagesInfo: UserListeningPackagesResponse = data[1];
            const userStudentStatus: StudentPlan = data[2];
            const listeningPackages = this.packageService.getActiveListeningPackages(
              listeningPackagesInfo
            );
            
            if (listeningPackages && listeningPackages.length > 0) {
              this.activePackages.push(...listeningPackages);
            }

            this.activePackages.map(pck => {
              pck.icon = this.getIcon(pck);
              this.product = this.googleAnalytics.convertProductToPackage(pck,'Aktif Üyeliklerim');
              this.productList.push(this.product);
              if(pck.isPremium && pck.isPaid){
                this.clicked = true;
              }
              if(pck.cancelReqSent){
                if(pck.nextRenewalDate){
                  this.$translate("account.cancelReqSendDetails", pck.nextRenewalDate).then(value => {
                    pck.cancelDescription = this.$sce.trustAsHtml(value);
                  });
                } else{
                  this.$translate("account.cancelReqSend").then(value => {
                    pck.cancelDescription = this.$sce.trustAsHtml(value);
                  });
                }
              } else{
                if(pck.period === "CONTRACTEDYEARLY"){
                  localStorage.setItem('userHasYearlyContracted', '1');
                } else if (pck.period === "YEARLY"){
                  localStorage.setItem('userHasYearly', '1');
                }
              }
            });

            this.packageService.getUserActivePackagesByIds().then(data => {
              localStorage.setItem('activePackages',data);

            } );

            this.ecommerce = this.googleAnalytics.setEcommerce(null,'Impression','Aktif Üyeliklerim',this.productList);
            this.googleAnalytics.trackEvent(angular.extend(JSON.parse(JSON.stringify(new ProductImpressionEvent)), {ecommerce : this.ecommerce, userPackage: localStorage.getItem('activePackages')}));





            const offerableListeningPackages = listeningPackagesInfo.offerablePackages
              .filter(offerablePackage => {
                if (
                  this.user.gsmOperator === GsmOperator.TURKCELL ||
                  this.user.gsmOperator === GsmOperator.BELARUS_LIFE ||
                  this.user.gsmOperator === GsmOperator.UKRAINE_LIFECELL ||
                  this.user.gsmOperator === GsmOperator.KKTCELL
                ) {
                  return (
                    offerablePackage.type !== ListeningPackageType.APPLESTORE &&
                    offerablePackage.type !== ListeningPackageType.GOOGLEPLAY
                  );
                } else {
                  return (
                    offerablePackage.type === ListeningPackageType.APPLESTORE ||
                    offerablePackage.type === ListeningPackageType.GOOGLEPLAY ||
                    offerablePackage.type === ListeningPackageType.CREDITCARD
                  );
                }
              })
              .map(offerablePackage => {
                return this.packageService.convertListeningPackage(
                  offerablePackage
                );
              });

            const offerablePaycellPackages = listeningPackagesInfo.offerablePackages
              .filter(offerablePackage => {
                if (
                  this.user.gsmOperator === GsmOperator.TURKCELL ||
                  this.user.gsmOperator === GsmOperator.OTHER ||
                  this.user.gsmOperator === GsmOperator.KKTCELL
                ) {
                  return (
                    offerablePackage.type === ListeningPackageType.CREDITCARD
                  );
                }
              })
              .map(offerablePackage => {
                return this.packageService.convertListeningPackage(
                  offerablePackage
                );
              });

            if (
              offerableListeningPackages &&
              offerableListeningPackages.length
            ) {
              this.packages.push(...offerableListeningPackages);
            }

            if (offerablePaycellPackages && offerablePaycellPackages.length) {
              this.paycellPackages.push(...offerablePaycellPackages);
            }

            this.packages = this.packages.filter(
              packageData =>
                !this.activePackages.filter(
                  activePackage => activePackage.id === packageData.id
                )[0]
            );
            this.paycellPackages = this.paycellPackages.filter(
              packageData =>
                !this.activePackages.filter(
                  activePackage => activePackage.id === packageData.id
                )[0]
            );

            // start: filter by relatedSDP
            if (this.packages.length > 0) {
              this.paycellPackages = this.paycellPackages.filter(
                packageData =>
                  !this.activePackages.filter(activePackage => {
                    packageData.relatedSDP &&
                      packageData.relatedSDP.length > 0 &&
                      activePackage.id === packageData.relatedSDP;
                  })[0]
              );
            }
            // end: filter by relatedSDP

            if (this.packages.length > 0) {
              this.notOffer = false;
            } else {
              this.notOffer = true;
            }

            this.selectedPackages =
              this.packages.length > 0 ? this.paycellPackages : this.packages;



            this.ecommerce = new Ecommerce();
            this.productList = [];

            var showCampaignPopup = !!localStorage.getItem('campaignedPackageIds');
            this.selectedPackages = this.selectedPackages.filter(selected => !(selected.isStudent && userStudentStatus.studentPlanStatus == StudentPlanStatus.LIMIT_EXCEEDED));
            this.selectedPackages.map(selected => {
              if(selected.isStudent){
                selected.studentPlanClass = userStudentStatus.studentPlanStatus == StudentPlanStatus.APPROVED ? 'student-approved' : 'student-other';
                this.$translate('account.studentPlanDesc.' + userStudentStatus.studentPlanStatus.toLowerCase()).then(value => {
                  selected.studentPlanDesc = this.$sce.trustAsHtml(value);
                });
              }
              this.product = this.googleAnalytics.convertProductToPackage(selected,'Satın Alabileceğim Üyelikler');
              this.productList.push(this.product);
              if(showCampaignPopup){
                var packageIds:string[] = localStorage.getItem('campaignedPackageIds').split(',');
                if(packageIds.indexOf(selected.id) > -1){
                  showCampaignPopup = false;
                  localStorage.removeItem('campaignedPackageIds');
                }
              }
            });
            if(showCampaignPopup){
              this.actionDispatcher.dispatch(new OpenCampaignDialogAction());
              localStorage.removeItem('campaignedPackageIds');
            }

            this.ecommerce = this.googleAnalytics.setEcommerce(null,'Impression','Satın Alabileceğim Üyelikler',this.productList);
            this.googleAnalytics.trackEvent(angular.extend(JSON.parse(JSON.stringify(new ProductImpressionEvent)), {ecommerce : this.ecommerce, userPackage: localStorage.getItem('activePackages')}));


          });
      });
  }

  public isTurkcellSubscriber(): boolean {
    return this.userService.isTurkcellSubscriber();
  }

  public manageSubscription(packageId: PackageThumbnail) {
    this.ecommerce = this.googleAnalytics.setEcommerce(packageId,'Click','Aktif Üyeliklerim');
    this.googleAnalytics.trackEvent(angular.extend(JSON.parse(JSON.stringify(new ProductClickEvent)), {ecommerce:this.ecommerce, userPackage:localStorage.getItem('activePackages')}));

    this.$state.go("manageSubscription", {
      packetId: packageId.id
    });
  }

  public getIcon(packageIcon: PackageThumbnail){
   return this.packageService.getPackageIcon(packageIcon);
  }

  public showButton(packageType: PackageThumbnail) {
    if(packageType.cancelReqSent){
      return false;
    }

    return !!packageType.manageSubscription;
  }

}



// WEBPACK FOOTER //
// ./src/app/my-account/my-account.controller.ts